import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../Components/Spinner";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import MandatorySign from "../Components/MandatorySign";
import ErrorMessage from "../Components/ErrorMessage";
import { categoryOptions, toolsOptions, regionOptions } from "../MCPs/ContstantValues"
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const SaveMcpModal = ({
    setPopupMex,
    account_id,
    show,
    handleClose,
    mcpData,
    runtime,
    files,
    setLoadingSave,
    setDraftedVersion,
    setOpenConfirmDeleteModal
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate();
    const { org_id, mcp_id, version_n } = useParams()
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [formData, setFormData] = useState({
        mcp_name: "",
        description: "",
        source_url: "",
        organization_ids: ["test"],
        category: [],
        transport_type: "HTTP",
        tools: ["AI"],
        license: "Proprietary",
        region: regionOptions.find(r => r.value === "europe-west8"),
    });

    const handleSave = async () => {
        setErrorMessage({ message: "", display: false });

        if (!formData.mcp_name) {
            setErrorMessage({ message: t.abilities.ability_name_req, display: true });
            return;
        }

        if (!formData.description) {
            setErrorMessage({ message: t.abilities.ability_desc_req, display: true });
            return;
        }

        if (formData.description.length > 300) {
            setErrorMessage({ message: t.abilities.ab_desc_long, display: true });
            return;
        }

        if (formData.category.length == 0) {
            setErrorMessage({ message: t.abilities.one_cat_req, display: true });
            return;
        }

        if (!formData.transport_type) {
            setErrorMessage({ message:  t.abilities.transp_req, display: true });
            return;
        }

        if (formData.tools.length == 0) {
            setErrorMessage({ message: t.abilities.tool_req, display: true });
            return;
        }

        if (!formData.license) {
            setErrorMessage({ message: t.abilities.license_req, display: true });
            return;
        }

        setLoading(true);
        setLoadingSave(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/save_mcp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    account_id,
                    org_id,
                    mcp_id,
                    mcp_name: formData.mcp_name,
                    description: formData.description,
                    source_url: formData.source_url,
                    organization_ids: formData.organization_ids,
                    category: formData.category,
                    transport_type: formData.transport_type,
                    tools: ["AI"],
                    license: formData.license,
                    files: files,
                    runtime: runtime,
                    region: mcpData.region
                }),
            });

            const result = await response.json();

            if (result.error == "not_authorized") {
                CloseModal()
                setPopupMex({ active: true, type: "error", message: "Organization auth..." })
                setTimeout(() => {
                    setPopupMex({ active: false, type: null, message: "" })
                    navigate(`/e8console/organizations`)
                }, 5000);
            }

            if (!response.ok) throw new Error("Failed to deploy ability");

            if (result.status == "success") {
                const new_drafted_version = result.new_drafted_version
                setDraftedVersion(new_drafted_version)
                const mainUrl = `/e8console/organizations/${org_id}/abilities`;

                const targetPath =
                    runtime === "python"
                        ? `${mainUrl}/ability-builder/python/${result.mcp_id}/${new_drafted_version}`
                        : `${mainUrl}/ability-builder/javascript/${result.mcp_id}/${new_drafted_version}`;

                navigate(targetPath);
                CloseModal()
            }
        } catch (err) {
            setErrorMessage({ message: err.message, display: true });
            setLoading(false)
            setLoadingSave(false)
        } finally {
            setLoading(false);
            setLoadingSave(false)
            setErrorMessage({ message: "", display: false });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        if (mcpData && show) {
            setFormData({
                mcp_name: mcpData.mcp_name || "",
                description: mcpData.description || "",
                source_url: mcpData.source_url || "",
                organization_ids: mcpData.organization_ids || ["test"],
                category: mcpData.category || [],
                transport_type: mcpData.transport_type || "HTTP",
                tools: mcpData.tools || ["AI"],
                license: mcpData.license || "Proprietary",
                region: regionOptions.find(r => r.value === mcpData.region) || regionOptions.find(r => r.value === "europe-west8"),
            });
        }
    }, [mcpData, show, mcp_id]);

    const CloseModal = () => {
        setFormData({
            mcp_name: mcpData.mcp_name || "",
            description: mcpData.description || "",
            source_url: mcpData.source_url || "",
            organization_ids: mcpData.organization_ids || ["test"],
            category: mcpData.category || [],
            transport_type: mcpData.transport_type || "HTTP",
            tools: mcpData.tools || ["AI"],
            license: mcpData.license || "Proprietary",
            region: regionOptions.find(r => r.value === "europe-west8"),
        })
        setErrorMessage({ message: "", display: false })
        handleClose();
        setLoading(false);
    }

    return (
        <Modal show={show} onHide={CloseModal} centered className="mcp_modal_custom">
            <div className="modal_header">
                <p className="modal_header_title">
                    {t.abilities.settings}
                </p>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div>
                        <div className="label_input">
                            <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                            <input
                                type="text"
                                name="mcp_name"
                                value={formData.mcp_name}
                                onChange={handleChange}
                                placeholder="Ex. Customer Support Bot"
                                className="register_form_first fade-in"
                            />
                        </div>
                        <div className="label_input">
                            <label className="input_label">{t.description} <MandatorySign message={t.mandatory_field} /></label>
                            <textarea
                                name="description"
                                value={formData.description}
                                onChange={handleChange}
                                placeholder={t.abilities.ab_placeholder}
                                className="register_form_first textarea_reg fade-in"
                            />
                        </div>
                        <div className="label_input">
                            <label className="input_label">{t.abilities.source_url}</label>
                            <input
                                type="text"
                                name="source_url"
                                value={formData.source_url}
                                onChange={handleChange}
                                placeholder="https://githubproject.com"
                                className="register_form_first fade-in"
                            />
                        </div>
                        <div className="persona_reg">
                            <div className="label_input">
                                <label className="input_label">{t.abilities.category} <MandatorySign message={t.mandatory_field} /></label>
                                <Dropdown drop="up" autoClose={"outside"}>
                                    <Dropdown.Toggle as="div" className="register_form_first fade-in pointer">
                                        {formData.category.length > 0
                                            ? `${formData.category.length} ${t.selected}`
                                            : t.select}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="custom_dropdown_menu">
                                        <div className="scrollable_dropdown_cont">

                                            {categoryOptions.map((cat) => {
                                                const isSelected = formData.category.includes(cat);

                                                return (
                                                    <Dropdown.Item
                                                        key={cat}
                                                        onClick={() => {
                                                            setFormData(prev => {
                                                                const alreadySelected = prev.category.includes(cat);

                                                                return {
                                                                    ...prev,
                                                                    category: alreadySelected
                                                                        ? prev.category.filter(c => c !== cat)
                                                                        : [...prev.category, cat]
                                                                };
                                                            });
                                                        }}
                                                        className="settings_link"
                                                    >
                                                        <i>
                                                            {isSelected
                                                                ? <MdOutlineCheckCircle />
                                                                : <MdOutlineCircle />}
                                                        </i>
                                                        {cat}
                                                    </Dropdown.Item>
                                                );
                                            })}
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            {/* <div className="label_input">
                                <label className="input_label">Tools <MandatorySign message={"Tools are required"} /></label>
                                <Dropdown drop="up" autoClose={"outside"}>
                                    <Dropdown.Toggle as="div" className="register_form_first fade-in pointer">
                                        {formData.tools.length > 0
                                            ? `${formData.tools.length} tools selected`
                                            : "Select Tools"}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu className="custom_dropdown_menu">
                                        <div className="scrollable_dropdown_cont">

                                            {Object.entries(toolsOptions).map(([group, items]) => (
                                                <div key={group}>
                                                    <div className="dropdown_group_label">{group}</div>
                                                    {items.map((tool) => (
                                                        <Dropdown.Item
                                                            key={tool}
                                                            onClick={() => {
                                                                setFormData(prev => {
                                                                    const alreadySelected = prev.tools.includes(tool);

                                                                    return {
                                                                        ...prev,
                                                                        tools: alreadySelected
                                                                            ? prev.tools.filter(t => t !== tool)
                                                                            : [...prev.tools, tool]
                                                                    };
                                                                });
                                                            }}
                                                            className="settings_link"
                                                        >
                                                            <i>
                                                                {formData.tools.includes(tool)
                                                                    ? <MdOutlineCheckCircle />
                                                                    : <MdOutlineCircle />}
                                                            </i>
                                                            {tool}
                                                        </Dropdown.Item>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div> */}
                        </div>
                        <div className="persona_reg">
                            <div className="label_input">
                                <label className="input_label">{t.abilities.region} <MandatorySign message={t.abilities.region_warning} /></label>
                                <p className="register_form_first register_form_first_disabled fade-in">
                                    {formData.region.label}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="delete_item_cont">
                    <button className="delete_item_btn" onClick={() => setOpenConfirmDeleteModal(true)}>{t.abilities.delete_ability}</button>
                </div>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>
                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                    >
                        {loading ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button className="modale_close_btn" onClick={CloseModal}>
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal >
    );
};

export default SaveMcpModal;